import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

/**
 * Entity to track whether a new workshop document notification has been sent to a user
 * Prevents duplicate notifications for the same document to the same user
 */
@Entity()
export class NewWorkshopDocumentNotification extends MongoEntity {
  static override _class = 'NewWorkshopDocumentNotification';
  static override _collectionName = 'notification';

  @Field(() => String)
  userID: Maybe<string>;

  @Field(() => String)
  documentID: Maybe<string>;

  @Field(() => String)
  participationID: Maybe<string>;

  @Field(() => Date)
  sentAt: Maybe<Date>;
}
